// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"PageSpinner-module__spinnerContainer--RU2Wv"};